<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      Profil
      @if (!isLoginSameAsSignUp) {
        <mat-icon
          matTooltip="OBS! Login og oprettelse stemmer ikke overens."
          class="ml-3 login-signup-warning"
        >warning</mat-icon>
      }
    </mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="settings-view">
      <dl fxFlex="45" class="settings-list">
        <dt>Oprettelse</dt>
        <dd>{{ value.signups.join(', ') }}</dd>
        <dt>Login</dt>
        <dd>{{ value.logins.join(', ') }}</dd>
        <dt>Aldersgrænse for mindreårige</dt>
        <dd>{{ value.underage }}</dd>
        @if (nemKontoEnabled) {
          <dt>Foretræk ansøgers NemKonto (frem for værges)</dt>
          <dd>{{ value.prefer_applicant_nem_konto ? 'Ja' : 'Nej'}}</dd>
        }
        <dt>Behandlingstid for udbetalinger</dt>
        <dd>{{ value.payment_request_notice_days || 2 }} dage</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="45" class="settings-list">
        <dt>Tvunget profil</dt>
        <dd>{{ value.force ? 'Ja' : 'Nej' }}</dd>
        <dt>Bekræft via e-mail ved oprettelse</dt>
        <dd>{{ value.confirmation ? 'Ja' : 'Nej' }}</dd>
        <dt>Bekræft kontooplysninger (popup) ved anmodning</dt>
        <dd>{{ value.account_alert_on_payment_request ? 'Ja' : 'Nej' }}</dd>
        <dt>Tillad kopi af afviste sager</dt>
        <dd>{{ value.allow_copy_of_rejection ? 'Ja' : 'Nej' }}</dd>
        <dt>Tillad kopi af bevilgede sager</dt>
        <dd>{{ value.allow_copy_of_approved ? 'Ja' : 'Nej' }}</dd>
        <dt>Tillad at dele ansøgninger</dt>
        <dd>{{ value.allow_share_applications ? 'Ja' : 'Nej' }}</dd>
      </dl>
    </div>
  } @else {
    <form [formGroup]="form">
      <div fxLayout="row">
        <div fxFlex="45" fxLayout="column" class="pr-3">
          <div formArrayName="logins" fxLayout="column" class="mb-3">
            <h4>Logins</h4>
            <mat-checkbox ngDefaultControl (change)="onLoginTypeToggle('email', $event.checked)"
                          [checked]="hasLoginType('email')">Email</mat-checkbox>
            <mat-checkbox ngDefaultControl (change)="onLoginTypeToggle('mitid', $event.checked)"
                          [checked]="hasLoginType('mitid')">MitID</mat-checkbox>
          </div>

          <div formArrayName="signups" fxLayout="column" class="mb-3">
            <h4>Signups</h4>
            <mat-checkbox ngDefaultControl (change)="onSignupTypeToggle('email', $event.checked)"
                          [checked]="hasSignupType('email')">Email</mat-checkbox>
            <mat-checkbox ngDefaultControl (change)="onSignupTypeToggle('mitid', $event.checked)"
                          [checked]="hasSignupType('mitid')">MitID</mat-checkbox>
          </div>
          <mat-form-field class="mb-3">
            <mat-label>Aldersgrænse for mindreårige</mat-label>
            <input matInput type="number" formControlName="underage">
            <mat-hint>Ansøgere under denne alder skal have en værge, som er ældre.</mat-hint>
            @if (form.controls['underage'].hasError('required')) {
              <mat-error>Obligatorisk.</mat-error>
            }
            @if (form.controls['underage'].hasError('min')) {
              <mat-error>Mindst 15 år.</mat-error>
            }
            @if (form.controls['underage'].hasError('max')) {
              <mat-error>Højst 25 år.</mat-error>
            }
          </mat-form-field>
          @if (nemKontoEnabled) {
            <div class="mb-3">
              <mat-checkbox ngDefaultControl formControlName="prefer_applicant_nem_konto">Foretræk ansøgers NemKonto (frem for værges)</mat-checkbox>
            </div>
          }
          <mat-form-field class="mb-3">
            <mat-label>Behandlingstid for udbetalinger</mat-label>
            <input matInput type="number" formControlName="payment_request_notice_days">
            <mat-hint>Antal dage fonden bruger på at behandle en udbetalingsanmodning.</mat-hint>
            @if (form.controls['payment_request_notice_days'].hasError('required')) {
              <mat-error>Obligatorisk.</mat-error>
            }
            @if (form.controls['payment_request_notice_days'].hasError('min')) {
              <mat-error>Mindst 2 dage.</mat-error>
            }
          </mat-form-field>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div fxFlex="45" fxLayout="column">
          <h4>Generelle indstillinger</h4>
          <mat-checkbox ngDefaultControl formControlName="force">Kun tilgå via profil</mat-checkbox>
          <mat-checkbox ngDefaultControl formControlName="confirmation">Email bekræftelse ved oprettelse</mat-checkbox>
          <mat-checkbox ngDefaultControl formControlName="account_alert_on_payment_request">
            <span style="white-space: break-spaces">Vis en popup med kontooplysninger, når ansøger indsender anmodning.</span>
          </mat-checkbox>
          <mat-checkbox ngDefaultControl formControlName="allow_copy_of_rejection">Tillad kopi af afslag.</mat-checkbox>
          <mat-checkbox ngDefaultControl formControlName="allow_copy_of_approved">Tillad kopi af bevilgede sager.</mat-checkbox>
          <mat-checkbox ngDefaultControl formControlName="allow_share_applications">Tillad at dele ansøgninger.</mat-checkbox>
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button class="action-edit" (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button class="action-cancel" (click)="doCancel()">Fortryd</button>
        <button mat-flat-button class="action-save" (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
